import { Container, Row, Col } from "react-bootstrap";
import './finalValueScreen.scss'
import { Button, Loader } from 'sfy-react'
import { useEffect, useState } from "react";
import constants from './constants'
import { postRequestAsync } from "./genericApi";
import { IntlProvider, FormattedNumber } from 'react-intl'
import { apiInstance } from "./apiInstance";
import downArrow from './assets/downIcon.svg';
import upArrow from './assets/upIcon.svg';
import amountper from './assets/amountpercent.png'
import RejectModal from "./Modal/rejectModal";
import ConfirmModal from "./Modal/confirmModal";
import DeviceNotEligible from './deviceNotEligibleScreen'
import ButtonContainer from "./buttonContainer";
import ErrorModal from "./Modal/errorModal";
import { getAmpleStoreDetails } from './apiInstance';
import pushToAnalytics, { getTimeDiff } from "./Analytics";

function TradeinFinalValue(props) {
 const { changeScreen } = props;
 let ampleStoreDetails = getAmpleStoreDetails();
 const ample_url = ampleStoreDetails.callbackurl;
 console.log(ample_url)
 const [showModal, setShowModal] = useState(false);
 const [disableBtn, setDisableBtn] = useState(false);
 const [offerList, setOfferList] = useState([]);
 const [tradeinFinalAmount, setTradeinFinalAmount] = useState(0);
 const [offerMaxAmount, setOfferMaxAmount] = useState(0);
 const [showLoader, setShowLoader] = useState(true);
 const ampleDetails = JSON.parse(localStorage.getItem("amplePayload"));
 const PSLId = ampleStoreDetails["pslid"];
 const PSCId = constants.PSCId;
 const brandId = localStorage.getItem('ampleBrand');
 const userId = localStorage.getItem("ampleWebUserId");
 const imei = localStorage.getItem("ampleImei");
 const skuModelId = localStorage.getItem("ampleVariantId");
 const brand = localStorage.getItem("ampleBrandName");
 const model = localStorage.getItem("ampleModelName");
 const variant = localStorage.getItem("ampleVariant");
 const productId = localStorage.getItem("ampleProductID");
 const insAns = localStorage.getItem("ampleInspectionAns");
 const ampleintegrationDetails = localStorage.getItem("ampleintegrationDetails");
 const ConsumerID = localStorage.getItem("ampleConsumerID");
 const [currencyCode, setCurrencyCode] = useState('INR');
 const [showRejectModel, setShowRejectModel] = useState(false);
 const [confirmModel, setConfirmModel] = useState(false);
 const [accepted, setAccepted] = useState(true)
 const [apiError, setError] = useState("")
 const [tradeInRefID, setTradeInRefID] = useState("");
 const [loaderText, setLoaderText] = useState("");
 const [showOffers, setShowOffers] = useState(false);
 const [isNpo, setIsNpo] = useState(false);
 const [enterTime, setEnterTime] = useState(new Date());
 const [selectedOffer, setSelectedOffer] = useState('');
 const getCurrencyCode = (t) => {
  return t && t.data && t.data.currency && t.data.currency.CurrencyCode || 'INR';
 }
 const closeModal = () => {
  setShowModal(false);
  setError("");
 }
 useEffect(() => {
  const currentTime = new Date();
  console.log("currentTime", currentTime)
  setEnterTime(currentTime);
 }, [])
 useEffect(() => {
  if (apiError) setShowModal(true);
 }, [apiError])
 const calculate_amount = async (trReqId) => {
  try {
   setError("");
   const calculateAmount = await postRequestAsync('/api/v2/TradeIn/calculateAmount', {
    "TradeInRequestID": trReqId,
    "flow": [
     "TRADE_IN"
    ]
   })
   if (calculateAmount && calculateAmount.success) {
    if (calculateAmount.data && (calculateAmount.data.uptoAmount || calculateAmount.data.npoAmount)) {
     let maxAmount = 0;
     let finalOffer = 0;
     if (calculateAmount.data.uptoAmount && calculateAmount.data.uptoAmount.MinAmount) {
      maxAmount = calculateAmount.data.uptoAmount.MinAmount
     } else if (calculateAmount.data.npoAmount && calculateAmount.data.npoAmount.MinAmount) {
      maxAmount = calculateAmount.data.npoAmount.MinAmount;
     }
     setTradeinFinalAmount(maxAmount);
     const currencyCode = getCurrencyCode(calculateAmount);
     setCurrencyCode(currencyCode);
     const offer_list = await postRequestAsync('/api/v2/TradeIn/getOffers', {
      "TradeInAmount": maxAmount,
      "ProductSubCategoryID": PSCId,
      "SkuModelID": skuModelId,
      "ProductID": productId,
      "BrandID": brandId,
      "PartnerServiceLocationID": PSLId
     })

     if (offer_list && offer_list.success && offer_list.data && offer_list.data.offer) {
      let offer_filter_list = offer_list.data.offer.filter((d) => {
       return d.mpns.filter((b) => {
        if (ampleDetails.BrandID) {
         return (b.BrandID == ampleDetails.BrandID && b.ProductSubCategoryID == PSCId)
        }
        return b.ProductSubCategoryID == PSCId
       }).length > 0
      })

      if (offer_filter_list && offer_filter_list.length > 0) {
       finalOffer = Math.max(...offer_filter_list.map(el => el.Value));
       const selected_offer = offer_filter_list.filter(key => (key.Value == finalOffer));
       if (selected_offer && selected_offer.length) {
        setSelectedOffer(selected_offer[0].OfferName);
        console.log("selected_offer[0].OfferName",selected_offer[0].OfferName)
       }
      }

      setOfferMaxAmount(finalOffer);
      if (maxAmount == 0) setIsNpo(true);
      setOfferList(offer_filter_list);
     } else if (offer_list && offer_list.success) {
      setOfferMaxAmount(finalOffer);
     }
    }
    const canceReq = await postRequestAsync('/api/v2/TradeIn/cancel',
     {
      "TradeInRequestID": trReqId,
      "UserID": userId,
      "Flow": "TRADE_IN"
     })
    setShowLoader(false);
   } else {
    if (calculateAmount && calculateAmount.msg && calculateAmount.msg.includes('#3004: We are unable to offer any')) {
     // setDisableBtn(true);
     setError(calculateAmount.msg);
     setShowLoader(false);
    }
   }
  } catch (e) {
   if (e && e.msg && (
    e.msg.includes('#3004: We are unable to offer any') ||
    e.msg.includes('#3005: Unable to proceed due to missing') ||
    e.msg.includes('#3018: Unable to proceed due to missing configuration.') ||
    e.msg.includes('#5034: Something went wrong'))) {
    setIsNpo(true);
   }
   //setError(e.msg);
   setShowLoader(false);
   const canceReq = await postRequestAsync('/api/v2/TradeIn/cancel',
    {
     "TradeInRequestID": trReqId,
     "UserID": userId,
     "Flow": "TRADE_IN"
    })
  }

 }
 useEffect(() => {
  (async () => {
   try {
    setShowLoader(true);
    setError("");
    setLoaderText("");
    let insAnswers = JSON.parse(insAns);
    const register = await postRequestAsync('/api/v2/TradeIn/register', {
     "CountryID": 105,
     "UserID": userId,
     "SkuModelID": skuModelId,
     "PartnerServiceLocationID": PSLId,
     "ProductUniqueID": imei,
     "integrationDetails": ampleintegrationDetails,
     "inspectionQuestionAnswerCodes": insAnswers,
     "Flow": "TRADE_IN"
    })

    if (register && register.success && register.data && register.data.tradeInRequest) {
     if (register.data.tradeInRequest.TradeInRequestID) {
      localStorage.setItem("ampleTradeinReqId", register.data.tradeInRequest.TradeInRequestID);
     }
     if (register.data.tradeInRequest.ReferenceID) {
      localStorage.setItem("ampleTradeinReqId", register.data.tradeInRequest.ReferenceID);
      setTradeInRefID(register.data.tradeInRequest.ReferenceID);
     }
     calculate_amount(register.data.tradeInRequest.TradeInRequestID);
    }

   }
   catch (e) {
    console.log('exception at register - offer - calculate amount - ', JSON.stringify(e));
    setError(e && e.msg);
    setShowLoader(false);
   }
  })()
 }, [])
 const on_reject_btn_click = () => {
  setShowModal(true);
  setShowRejectModel(true);
  pushToAnalytics(
   'Exchange value - Reject',
   {
    Upto_value: tradeinFinalAmount,
    Max_Offer_Price: offerMaxAmount,
    Selected_Offer_Name: selectedOffer,
    Unique_Key: localStorage.getItem('ampleUniquekey'),
    Time_Spent_On_Exchange_Value_Screen: getTimeDiff(new Date(), enterTime)
   }
  )

 }
 const closeWindow = () => {
 }
 const showHideMoreOffers = () => {
  setShowOffers(!showOffers);
  pushToAnalytics(
   'Exchange value - Show more offers',
   {
    Total_Offers: offerList && offerList.length || 0,
    Unique_Key: localStorage.getItem('ampleUniquekey')
   }
  )
 }
 const on_do_not_accept_btn_click = async () => {
  apiInstance.defaults.headers['App'] = 'Servify-TradeInLead-Web'
  apiInstance.defaults.headers['Source'] = 'Ample';
  try {
  setShowLoader(true);
   const rejectData = await postRequestAsync('api/v2/TradeIn/ample/mapData', {
    "TradeInReferenceID": tradeInRefID,
    "ConsumerID": ConsumerID,
    "QuoteAmount": tradeinFinalAmount,
    "ConsumerConsent": false
   });
   setShowLoader(false);
   setShowModal(true);
   setConfirmModel(true);
   setAccepted(false);
   setTimeout(() => {
    window.open('https://www.imagineonline.store/pages/thank-you-1', "_self");
   }, 5000);
  }
  catch (e) {
   setShowLoader(false);
   setShowModal(true);
   setConfirmModel(true);
   setAccepted(false);
   setTimeout(() => {
   }, 5000);
  }
 }
 const on_accept_btn_click = async () => {
  apiInstance.defaults.headers['App'] = 'Servify-TradeInLead-Web'
  apiInstance.defaults.headers['Source'] = 'Ample';
  try {
   setShowLoader(true);
   const acceptData = await postRequestAsync('api/v2/TradeIn/ample/mapData', {
    "TradeInReferenceID": tradeInRefID,
    "ConsumerID": ConsumerID,
    "QuoteAmount": tradeinFinalAmount,
    "ConsumerConsent": true,
   })
   setShowLoader(false);
   setConfirmModel(true);
   setShowModal(true);
   setTimeout(() => {
    window.open("https://www.imagineonline.store/pages/thank-you", "_self");
   }, 5000);
  }
  catch (e) {
   setShowLoader(false);
   setConfirmModel(true);
   setShowModal(true);
   setTimeout(() => {
    closeWindow();
   }, 5000);
  }
 }
 const on_no_btn_click = async () => {
  setShowModal(false);
  setShowRejectModel(false);
 }
 const on_yes_btn_click = async () => {
  setShowModal(false);
  setShowRejectModel(false);
  on_do_not_accept_btn_click();
 }
 const onClickHereBtnClick = () => {
  }
 return (
  <Container fluid className="p-0 m-0 g-0" style={{ backgroundColor: '#FFFFFF' }}>
   {
    showModal && showRejectModel && <RejectModal showModal={showModal} closeModal={closeModal} no_btn_click={on_no_btn_click} yes_btn_click={on_yes_btn_click} />
   }
   {
    showModal && confirmModel && <ConfirmModal accept={accepted} showModal={showModal} closeModal={closeModal} onClick={onClickHereBtnClick} />
   }
   {
    showLoader ?
     <Loader isContentLoader loaderText={loaderText} />
     :
     ''
   }
   {
    isNpo ? <DeviceNotEligible brand={brand} model={model} variant={variant} closeBtnClick={on_do_not_accept_btn_click} /> : <Container>
     <div>
      <div className="finalScreenHeader">
       Congratulations!
      </div>
      <div className="finalScreenSubHeader">
       <div className="paragraph_center">Exchange Value Generated</div>
      </div>
     </div>
     <div>
      <Row>
       <Col>
        <div className='tr-cd-final-amount'>
         <div className="tr-fa-header">
          Get Up to
         </div>
         <div className="tr-fa-amount">
          <IntlProvider locale="en" defaultLocale="en">
           <FormattedNumber
            value={tradeinFinalAmount}
            style="currency"
            currency={currencyCode} />
          </IntlProvider>*
         </div>
         {<div className="tr-exchange-header">
          Exchange Device
         </div>}

         {<Col className='d-flex'>
          <div className='tr-exchange-details'>
           {`${brand || ""} ${model || ""} | ${variant}`}
          </div>
         </Col>}
         {/*offerList && offerList.length && <div className="tr-offer-amount">
          <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center" }}>
           <div style={{ width: "50px", height: "50px", display: "flex", justifyContent: "center", alignItems: "center" }}>
            <img alt="" src={amountper} />
           </div>
           <div className="tr-offer-amount-desc">{`Get Up to  `} <span className="offerHilight">
            <IntlProvider locale="en" defaultLocale="en">
             <FormattedNumber
              value={offerMaxAmount}
              style="currency"
              currency={currencyCode} />
            </IntlProvider>
           </span>
            {`   as an additional bonus on purchase of new device`}
           </div>
          </div>
         </div> || ""
   */}
        </div>
       </Col>
      </Row>
      {/*<div style={{ padding: '0px 24px 24px' }}>
       <Row>
        {offerList && offerList.length && <Col xs={12} className='d-flex vertical-center'>
         <div className='tr-fc-header' onClick={showHideMoreOffers}>

          {showOffers && "Hide More Offers" || "Show More Offers"}
          <img style={{ paddingTop: '2px' }} src={showOffers ? upArrow : downArrow} alt=" Arrow" />
         </div>
        </Col> || ""
        }
        <Col xs={12} style={{ marginTop: '2px' }}>
         {
          showOffers && offerList && offerList.map((offer, index) => {
           return <Row key={index}>
            <Col xs={12}>
             <div className="offer-header">{offer.OfferName}</div>
            </Col>
            <Col xs={12}>
             <div className="offer-desc">{offer.OfferDesc}
             </div>
            </Col>
           </Row>

          })
         }


        </Col>
        <Col xs={12}>
         <div className="disClaimer">
          *The final exchange value will be determined on the basis of a physical & hardware diagnosis of your device and the availability of the offer (at the time of exchange) at the retail store or by our logistics agent.
         </div>
        </Col>
       </Row>


        </div>*/}
     </div>
     {apiError && <ErrorModal error={apiError} showModal={showModal} closeModal={closeModal} onClick={closeModal} /> || ""}
     <div style={{ paddingBottom: '10px' }}>
      <ButtonContainer
       isDisabled={disableBtn}
       BtnOneText={'Accept'}
       BtnTwoText={'Reject'}
       onBtnOneClick={on_accept_btn_click}
       onBtnTwoClick={on_reject_btn_click}
       BtnOneClass={'pwa-continue-btn'}
       BtnTwoClass={'reject-continue-btn'} />
     </div>
    </Container>
   }
  </Container >

 );
}
export default TradeinFinalValue;